// extracted by mini-css-extract-plugin
module.exports = {"spinWrapper":"index_spinWrapper__2Wt-g","exception":"index_exception__dMbw2"};